import React from 'react';
import { COMPANY } from '../data/mock';

export default function Terms() {
  return (
    <div className="bg-white">
      <div className="bg-slate-50 border-b border-slate-200">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 text-center">
          <h1 className="font-serif text-4xl md:text-5xl font-semibold text-slate-900">Terms of Service</h1>
          <p className="mt-2 text-slate-600">Last updated: January 2025</p>
        </div>
      </div>

      <article className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 prose prose-slate max-w-none">
        <p className="text-slate-600">
          Welcome to {COMPANY.name}, operated by {COMPANY.corp}. These Terms of Service govern your use of our
          website and the purchase of products through it. By accessing or placing an order, you agree to be bound
          by these terms.
        </p>

        <h2 className="font-serif text-2xl text-slate-900 mt-8 mb-3">1. Use of the Site</h2>
        <p className="text-slate-600">
          You agree to use our website only for lawful purposes and in a way that does not infringe on the rights of
          others. You must be at least 18 years old or have parental consent to make a purchase.
        </p>

        <h2 className="font-serif text-2xl text-slate-900 mt-8 mb-3">2. Orders &amp; Payment</h2>
        <p className="text-slate-600">
          All orders are subject to acceptance and availability. Prices are listed in U.S. dollars. We reserve the
          right to limit quantities or refuse any order at our discretion.
        </p>

        <h2 className="font-serif text-2xl text-slate-900 mt-8 mb-3">3. Shipping</h2>
        <p className="text-slate-600">
          Orders are typically shipped within 1 business day via USPS Standard Shipping, with delivery in 2 to 4
          business days. Shipping is complimentary on all orders within the continental United States.
        </p>

        <h2 className="font-serif text-2xl text-slate-900 mt-8 mb-3">4. Returns &amp; Refunds</h2>
        <p className="text-slate-600">
          We accept returns within 30 days of delivery. Items must be unused and in their original packaging.
          Contact our customer service team at {COMPANY.email} to initiate a return.
        </p>
        <p className="text-slate-600 mt-3">
          <span className="font-medium text-slate-800">Return Address:</span> {COMPANY.returnAddress}
        </p>

        <h2 className="font-serif text-2xl text-slate-900 mt-8 mb-3">5. Intellectual Property</h2>
        <p className="text-slate-600">
          All content on this site, including text, images, logos, and graphics, is the property of {COMPANY.corp}
          and is protected by applicable intellectual property laws.
        </p>

        <h2 className="font-serif text-2xl text-slate-900 mt-8 mb-3">6. Limitation of Liability</h2>
        <p className="text-slate-600">
          To the maximum extent permitted by law, {COMPANY.corp} shall not be liable for any indirect, incidental,
          special, or consequential damages arising from your use of our products or services.
        </p>

        <h2 className="font-serif text-2xl text-slate-900 mt-8 mb-3">7. Contact</h2>
        <p className="text-slate-600">
          For questions about these Terms, contact us at {COMPANY.email} or {COMPANY.phone}. Our mailing address is
          {' '}{COMPANY.address}.
        </p>
      </article>
    </div>
  );
}
